// eslint-disable-next-line import/no-extraneous-dependencies
import { CountUp } from 'countup.js';

const SELECTORS = {
  container: '.company-numbers',
  countNumber: '[data-number-count]',
};
/**
 *Set count style properties to animate
 */
const countNumbers = () => {
  const counters = document.querySelectorAll(SELECTORS.countNumber);
  counters.forEach((element) => {
    const targetValue = element.getAttribute('data-number-count');
    let decimalPlaces = 0;
    let decimal = '.';
    if (element.hasAttribute('data-replace-dot-comma')) {
      decimal = ',';
    }
    if (targetValue.split('.')[1] !== undefined) {
      decimalPlaces = targetValue.split('.')[1].length;
    } else if (targetValue.split(',')[1] !== undefined) {
      decimalPlaces = targetValue.split(',')[1].length;
    }
    let duration = 3;
    if (+targetValue < 100) {
      duration = 4;
    }
    const options = {
      startVal: 0,
      duration,
      decimalPlaces,
      separator: '',
      decimal,
    };
    const countUp = new CountUp(element, +targetValue, options);
    if (!countUp.error) {
      countUp.start();
    } else {
      // eslint-disable-next-line no-console
      console.error(countUp.error);
    }
  });
};

/**
 * Observe to section is on screen
 */
const containerObserver = () => {
  const targetElement = document.querySelector(SELECTORS.container);
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if (targetElement.classList.contains('is-visible')) {
          countNumbers();
          observer.disconnect();
        }
      }
    });
  });
  observer.observe(targetElement, { attributes: true });
};

document.addEventListener('DOMContentLoaded', () => {
  containerObserver();
});
